function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("polygon", {
  fill: "#B4B4B4",
  points: "15.228,17.712 21.372,19.127 17.711,32.114 24.207,48.878 27.748,47.107 29.4,62.104 23.261,60.569  17.478,66.823 19.365,80.637 46.52,62.933 52.892,76.151 46.991,77.923 45.1,88.55 50.064,93.27 57.619,87.958 65.527,92.328  54.312,113.577 55.373,118.896 67.183,123.26 57.97,129.396 53.719,144.393 62.102,154.189 69.065,152.066 72.967,155.963  78.868,148.288 78.279,143.566 90.083,148.877 95.396,160.568 105.432,162.104 109.092,172.373 105.667,176.738 108.148,185.949  113.814,187.371 127.749,179.695 132.232,182.645 129.164,184.18 134.709,192.441 140.848,195.04 141.207,199.178 177.215,200  184.771,193.035 182.766,184.771 168.479,171.782 167.648,157.146 151.479,159.15 130.579,139.785 118.302,139.436 90.32,115.586  90.32,107.085 65.527,69.425 58.445,44.159 60.686,32.358 53.135,26.216 42.859,8.503 30.815,0 20.781,1.535 17.478,5.908 "
});

var Svg30 = function Svg30(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "VER",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg30, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/30.e9d32048.svg";
export { ForwardRef as ReactComponent };